import {
  Component,
  OnInit,
  HostListener,
  ViewChild,
  Output,
  EventEmitter
} from '@angular/core';
import { BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import { FormElementBase } from '../form-element-base';

@Component({
  selector: 'date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.css']
})
export class DatePickerComponent extends FormElementBase implements OnInit {
  datepickerConfig = {};
  isOpen = false;

  errorMessage: string;
  i: number;
  // emit output variables
  emitOutput: Array<any> = [];

  @ViewChild('dp', { static: false }) datepicker: BsDatepickerDirective;

  @HostListener('window:scroll')
  onScrollEvent() {
    if (this.settings.hideOnScroll) {
      this.datepicker.hide();
    }
  }

  constructor() {
    super();
  }

  ngOnInit() {
    this.datepickerConfig = {
      isAnimated: this.settings.isAnimated,
      adaptivePosition: this.settings.adaptivePosition,
      dateInputFormat: this.settings.dateFormat,
      returnFocusToInput: this.settings.returnFocusToInput,
      selectFromOtherMonth: this.settings.selectDateFromOtherMonth,
      containerClass: this.settings.colorTheme
    };
  }

  getDatePickerConfig() {
    return this.datepickerConfig;
  }

  valueChanges(data) {
    this.emitOutput = [];
    this.emitOutput.push({
      name: this.settings.name,
      value: data
    });
    this.inputUpdated.emit(this.emitOutput);
  }

  onChange($event) {
    this.isOpen = false;
    this.valueChanges($event);
    if (this.inputEnterEvent) this.inputEnterEvent.emit($event);
  }

  calanderClicked() {
    this.isOpen = !this.isOpen;
  }
}
